import { watch } from 'vue'

import type { ComputedRef } from 'vue'

interface AudienceStoreScopeOptions {
  scopedStoreIds: ComputedRef<number[] | null>
  getSelectedIds: () => number[]
  setSelectedIds: (ids: number[]) => void
  getRestoreIds: () => number[]
  emptyMeansUnrestricted?: boolean
}

export default function useAudienceStoreScope({
  scopedStoreIds,
  getSelectedIds,
  setSelectedIds,
  getRestoreIds,
  emptyMeansUnrestricted = false
}: AudienceStoreScopeOptions): void {
  // `immediate: true` catches an audience that's already scoped when the page loads in edit
  // mode with a stale store selection (e.g. the audience's own scope narrowed after this form
  // was last saved). `previousScope` is `undefined` on that first call, so it can never trigger
  // the "restore" branch below — only the initial data can be pruned, never wiped.
  watch(
    scopedStoreIds,
    (newScope, previousScope) => {
      if (newScope) {
        const selectedIds = getSelectedIds()
        const prunedIds = selectedIds.filter((id) => newScope.includes(id))
        if (prunedIds.length !== selectedIds.length) {
          setSelectedIds(emptyMeansUnrestricted && prunedIds.length === 0 ? [...newScope] : prunedIds)
        }
      } else if (previousScope) {
        setSelectedIds(getRestoreIds())
      }
    },
    { immediate: true }
  )
}
